import { render } from "./ProcurePageCard.vue?vue&type=template&id=60825b9d&scoped=true"
import script from "./ProcurePageCard.vue?vue&type=script&lang=js"
export * from "./ProcurePageCard.vue?vue&type=script&lang=js"

import "./ProcurePageCard.vue?vue&type=style&index=0&id=60825b9d&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60825b9d"]])

export default __exports__